import PropTypes from 'prop-types';
import Amount from 'Components/Molecules/Amount/Amount';
import { OPERATIONS_TYPES } from 'Utils/constants';

export default function RecurrenceAmount(props) {
    const { operation, className } = props;

    const isIncome = operation.invoice_type === OPERATIONS_TYPES.CASH_IN;
    const absAmount = Math.abs(operation.amount);
    const amount = isIncome ? absAmount : -absAmount;

    return <Amount amount={amount} isIncome={isIncome} className={className} />;
}

RecurrenceAmount.propTypes = {
    operation: PropTypes.shape({
        amount: PropTypes.number,
        invoice_type: PropTypes.string,
    }).isRequired,
    className: PropTypes.string,
};
